import { render, staticRenderFns } from "./TradingInputPricePopup.vue?vue&type=template&id=24ed4f12&scoped=true&"
import script from "./TradingInputPricePopup.vue?vue&type=script&lang=js&"
export * from "./TradingInputPricePopup.vue?vue&type=script&lang=js&"
import style0 from "./TradingInputPricePopup.vue?vue&type=style&index=0&id=24ed4f12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ed4f12",
  null
  
)

export default component.exports